import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import greenSnowFlake from '@/images/green-snowflake.png';
import greenKey from '@/images/green-key.png';
import greenKeyFR from '@/images/green-key-fr.png';

// Enums
import { Locales } from '@/enums/locales';

// Components
import RSEcard from './RSEcard.vue';

// Composables
import useLocale from '@/vue/composables/useLocale';

interface IRSEblock {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RSEblock',
  props: {
    isCriteriaFloconVert: { type: Boolean },
    isCriteriaCleVerte: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
};

const locale = ref<string>(useLocale());

// Props


// Refs
const content = ref<{ [key: string]: string }>(window.content);

// Computed values
const greenKeyLogo = computed<string>(() => {
  const localeMap: Record<string, string> = {
    [Locales.FR]: greenKeyFR,
    [Locales.UK]: greenKey,
    [Locales.NL]: greenKey,
  };
  return localeMap[locale.value] || greenKeyFR;
});

// Compute the eco-responsible commitment labels title based on the criteria
const Title = computed<string>(() => {
  if (props.isCriteriaFloconVert && props.isCriteriaCleVerte) {
    return content.value.eco_responsible_commitment_labels_title_if_both;
  } else if (props.isCriteriaCleVerte) {
    return content.value.eco_responsible_commitment_labels_title_if_cleverte;
  } else if (props.isCriteriaFloconVert) {
    return content.value.eco_responsible_commitment_labels_title_if_flaconvert;
  }
  return '';
});


// Data for cards
const greenSnowFlakePopupData = {
  title: content.value.eco_responsible_commitments_green_snowflake_label,
  description: content.value.eco_responsible_commitments_green_snowflake_text,
  icon: greenSnowFlake,
};

const greenKeyPopupData = {
  title: content.value.eco_responsible_commitments_green_key_label,
  description: content.value.eco_responsible_commitments_green_key_text,
  icon: greenKeyLogo.value,
};

return { __sfc: true,locale, props, content, greenKeyLogo, Title, greenSnowFlakePopupData, greenKeyPopupData, RSEcard }
}

})